/**
 * Limpia el caché del navegador para forzar recarga de assets actualizados.
 */
import { removeDataInStorage } from "utils/storage/manageLocalStorage";
import { logger } from "utils/logger";

export const clearBrowserCache = async () => {
  try {
    // localStorage.clear();
    // 1. Limpiar almacenamiento local (solo usuario logueado, no estado del Tour) y de sesión
    removeDataInStorage("userPayload");
    sessionStorage.clear();

    // 2. Limpiar caches del navegador (si existen y están disponibles)
    if ("caches" in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }

    // 3. Eliminar service workers registrados (opcional)
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((reg) => reg.unregister()));
    }

    // 4. Recargar la app para aplicar cambios
    window.location.reload(true); // true fuerza reload desde el servidor
  } catch (error) {
    logger.error("Error al intentar limpiar la caché del navegador:", error);
  }
};
